import { CreateRoleRequest, EntityType, FolderRoleType, OrganizationRoleType, PointRoleType, RoleAssignment, TopicRoleType } from '../../types';
import { delWithData, get, logWithAmplitude, put, throwHttpError } from './api';

export async function removeRoleForEntity(
    amplitude_callsite: string,
    entity_id: string,
    role_request: CreateRoleRequest
) {
    const response = await fetch(`/api/roles/${entity_id}`, delWithData(role_request));

    if (!response.ok) {
        await throwHttpError('An error occurred while removing the role for the entity.', response);
    }

    logWithAmplitude(amplitude_callsite, 'Remove Role for entity');
}

export async function updateRoleForEntity(
    amplitude_callsite: string,
    entity_id: string,
    role_request: CreateRoleRequest
) {
    const response = await fetch(`/api/roles/${entity_id}`, put(role_request));

    if (!response.ok) {
        await throwHttpError('An error occurred while updating the account.', response);
    }

    logWithAmplitude(amplitude_callsite, 'Update Role for entity');
}

export async function getRolesForEntity(
    amplitude_callsite: string,
    entity_id: string,
    entity_type: EntityType
) {
    const response = await fetch(`/api/roles/${entity_id}/type/${entity_type}`, get());

    if (!response.ok) {
        await throwHttpError('An error occurred while getting the roles for the entity.', response);
    }

    logWithAmplitude(amplitude_callsite, 'Get All Roles for entity');
    return await (response.json() as Promise<RoleAssignment[]>);
}

export async function addRoleForEntity(
    amplitude_callsite: string,
    entity_id: string,
    role_request: CreateRoleRequest
) {
    const response = await fetch(`/api/roles/${entity_id}`, put(role_request));

    if (!response.ok) {
        await throwHttpError('An error occurred while adding the role for the entity.', response);
    }

    logWithAmplitude(amplitude_callsite, 'Add Role for entity');
}

export function createRoleRequestFromRole(r: RoleAssignment): CreateRoleRequest {
    if ((r.role as TopicRoleType).TopicRoleType !== undefined) {
        return {
            email: r.email,
            level: {
                TopicPermissionLevelType: (r.role as TopicRoleType).TopicRoleType?.level,
            },
        };
    } else if ((r.role as FolderRoleType).FolderRoleType !== undefined) {
        return {
            email: r.email,
            level: {
                FolderPermissionLevelType: (r.role as FolderRoleType).FolderRoleType?.level,
            },
        };
    } else if ((r.role as PointRoleType).PointRoleType !== undefined) {
        return {
            email: r.email,
            level: {
                PointPermissionLevelType: (r.role as PointRoleType).PointRoleType?.level,
            },
        };
    } else if ((r.role as OrganizationRoleType).OrganizationRoleType !== undefined) {
        return {
            email: r.email,
            level: {
                OrganizationPermissionLevelType: (r.role as OrganizationRoleType)?.OrganizationRoleType?.level,
            },
        };
    } else {
        throw new Error('Bad RoleAssignment object');
    }
}
